// extracted by mini-css-extract-plugin
export default {"footer":"juo6cKLOgMdbcbP2Curb"};